import { mapGetters } from 'vuex';

export default {
    name: 'mvtRange',
    emits: ['update:modelValue'],
    props: {
        data: {
            type: Array,
            required: true,
        },
        modelValue: {
            type: Array,
            default: [],
        },
        theme: {
            type: String,
            default: '',
        },
        noDefault: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        options: {
            type: Object,
            default: () => ({
                defaultValue: [0, 0],
            }),
        },
        label: {
            type: String,
            default: '',
        },
    },
    methods: {
        changeRange(value) {
            let _arr = [...this._value];
            if (this.rangeValue === 0 || this.rangeValue === this.data[this.data.length - 1].value) {
                _arr[0] = value;
                _arr[1] = 0;
            } else if (value === this.data[0].value) {
                _arr[0] = 0;
                _arr[1] = 0;
            } else if (value === this.data[this.data.length - 1].value) {
                _arr[0] = this.rangeValue;
                _arr[1] = 0;
            } else if (value > this.rangeValue) {
                _arr[0] = this.rangeValue;
                _arr[1] = value;
            } else {
                _arr[0] = value;
                _arr[1] = this.rangeValue;
            }
            this._value = _arr;
            this.rangeValue = value;
        },
    },
    data() {
        return {
            rangeValue: 0,
        };
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        changed() {
            if (this.options.defaultValue !== undefined) {
                return this._value[0] != this.options.defaultValue[0] || this._value[1] != this.options.defaultValue[1];
            }
            return false;
        },
        _value: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            },
        },
    },
};
